/**
 * Client-Safe Logger
 * 
 * Simple console wrapper for use in browser/client components.
 * For server-side logging with PostHog integration, use '@/src/server/lib/logger'
 */

const isDevelopment = process.env.NODE_ENV === 'development'

export const clientLogger = {
  debug: (obj: any, msg?: string) => {
    if (isDevelopment) {
      if (typeof obj === 'string') {
        console.debug(obj)
      } else {
        console.debug(msg || 'Debug:', obj)
      }
    }
  },
  
  info: (obj: any, msg?: string) => {
    if (typeof obj === 'string') {
      console.info(obj)
    } else {
      console.info(msg || 'Info:', obj)
    }
  },
  
  warn: (obj: any, msg?: string) => {
    if (typeof obj === 'string') {
      console.warn(obj)
    } else {
      console.warn(msg || 'Warning:', obj)
    }
  },
  
  error: (obj: any, msg?: string) => {
    if (typeof obj === 'string') {
      console.error(obj)
    } else {
      console.error(msg || 'Error:', obj)
    }
  },
}
